exports.onRouteUpdate = function () {
  // Don't track while developing.
  if (typeof window !== "undefined") {
    if (window.fbq != null) {
      window.fbq("track", "Lead", { currency: "USD", value: 9.99 });
    }
  }
};
